/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';
import SearchListingContainer from 'src/components/search-listing/SearchListingContainer';
import {
  fetchSearchResults, SearchType, selectSearch,
} from 'src/redux/slices/postSearch';
import { useAppDispatch, useAppSelector } from 'src/redux/hooks';
import { selectThreadDetailOp } from 'src/redux/slices/threadDetailSlice';
import { OpPost } from 'src/types/DiscussionPost';
import { getThreadDetail } from 'src/constants/pages';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { AppState } from 'src/redux/store';
import FetchStatus from 'src/types/FetchStatus';
import subMonths from 'date-fns/subMonths';
import { createSearchAPIContract } from '../search-listing/utils/createSearchAPIContract';
import { SearchDataRequestType } from '../../types/Search';

export interface SimilarDiscussionsProps {
  searchByTitle?: string;
  searchByContent?: string;
}

const SimilarDiscussions: React.FC<SimilarDiscussionsProps> = ({
  searchByTitle = '',
  searchByContent = '',
}) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { pathname } = useRouter();
  const opPost = useAppSelector<OpPost>(selectThreadDetailOp);
  const threadId = opPost && opPost.threadId;
  const concatedSearchTerm = `${searchByTitle.trim()} ${searchByContent.trim()}`;
  const onThreadDetailsPage = pathname === getThreadDetail('[threadId]');
  const similarDiscussionStatus = useAppSelector(
    (state: AppState) => selectSearch(state, SearchType.similarDiscussions).status,
  );

  useEffect(() => {
    dispatch(
      fetchSearchResults({
        type: SearchType.similarDiscussions,
        request: createSearchAPIContract({
          pageSize: 3,
          searchTerm: concatedSearchTerm.trim(),
          searchDataRequestType: SearchDataRequestType.SIMILAR_DISCUSSIONS,
          startDate: subMonths(new Date(), 12).getTime(),
          endDate: new Date().getTime(),
          ...(onThreadDetailsPage && threadId && { excludeThread: threadId }),
        }),
      }),
    );
  }, [searchByTitle, searchByContent]);

  if (similarDiscussionStatus === FetchStatus.failed) return null;
  return (
    <div data-testid="similar-discussions-container">
      <h2>{t('similarDiscussions')}</h2>
      <SearchListingContainer type={SearchType.similarDiscussions} showAvatar={false} />
    </div>
  );
};
export default SimilarDiscussions;
